import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import jsonp from 'jsonp';
import _get from 'lodash.get';
import NoResultTopStories from 'routes/topic/components/Desktop/NoResultTopStories/NoResultTopStories';
// import WithFilterLHS from 'routes/topic/components/Desktop/FilterLHS/WithFilterLHS';
import AboutTopic from 'routes/topic/components/Desktop/AboutTopic/AboutTopic';
import makeRequest from 'utils/makeRequest';
import Link from 'components/Link';
import { getExperimentRefresh } from 'utils/experimentUtils';
import { loadAllAdsFromQueue } from 'helpers/ads/redux';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import { getSearchApi } from 'components_v2/desktop/Header/Search/config';
import { TOPIC_API, ETIMES_TOPIC_API, TOPIC_CARD_TYPE } from 'constants/index';
import Search from 'components_v2/desktop/Header/Search';
// import AdCaller from 'helpers/ads/adCaller';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import BreadCrumb from 'components_v2/common/BreadCrumb/BreadCrumb';
import SocialSharing from 'routes/articleshow_v2/components/common/SocialWidget';
import gaWrapper from 'helpers/analytics/gaWrapper';
import { isSearchedKeywordValid } from 'utils/searchOverlayUtils';
import { UseIntersectionObeserver } from 'routes/home/layouts/India/context';
// import ToiPlusWidgets from '../../components/Desktop/ToiPlusWidgets/ToiPlusWidgets';
import TileWidget from '../../components/Desktop/TopicTile';
import PhotoVideoTile from '../../components/Desktop/PhotoVideoTile';
import s from './Topic.scss';
// import { loadTopicTabData, loadKeywordsFacetData } from '../../redux';
import { loadKeywordsFacetData } from '../../redux';
import { ContentLoadCount } from '../../components/Common/constants';
import TopicCard from '../../components/Common/TopicCard';
import PhotosSection from '../../components/Common/PhotosSection';
import AwardsSection from '../../components/Common/AwardsSection';
import Filmography from '../../components/Common/Filmography';
import RelatedCelebs from '../../components/Common/RelatedCelebs';
import LinksList from '../../../../components_v2/desktop/LinksList/LinksList';

function Topic(props) {
  const pageToTabMapping = {
    news: 'Articles',
    photos: 'Photos',
    videos: 'Videos',
    books: 'Books',
    filmography: 'Filmography',
    awards: 'Awards',
  };

  const photoLoadMoreDataCount = 33;
  const {
    newsData = [],
    searchKeyword,
    totalCount,
    topicData,
    adData: ads,
    isPrime,
    gaCategory,
    breadcrumbs,
    loadAllAds,
    page,
    photogalleryDataRendered,
    photostoryDataRendered,
    tabsData,
    curpg,
    frmEtimes,
    trendingCelebs,
    relatedCelebs,
    moreFromEtimes,
    etBreadcrumbs,
  } = props;

  const TOPIC_API_URL = frmEtimes ? `${ETIMES_TOPIC_API}` : `${TOPIC_API}`;
  const moreFromEtimesData = moreFromEtimes?.find(el => el.tn === 'seo_widget');
  let rhsAd =
    Array.isArray(ads) && ads.length > 0
      ? ads.filter(ad => ad.pos === 'rhs')
      : undefined;
  rhsAd = Array.isArray(rhsAd) && rhsAd.length > 0 ? rhsAd[0] : undefined;

  const photosPerPageCount =
    (ContentLoadCount.web && ContentLoadCount.web.photos) || 33;
  const vidoesPerPageCount =
    (ContentLoadCount.mweb && ContentLoadCount.web.photos) || 32;

  const inititalHidePhotoMoreButton = !(
    props.photos &&
    Array.isArray(props.photos) &&
    props.photos.length >= photosPerPageCount
  );

  const inititalHideVideoMoreButton = !(
    props.videos &&
    Array.isArray(props.videos) &&
    props.videos.length >= vidoesPerPageCount
  );

  const [selectedTab, setSelectedTab] = useState(
    pageToTabMapping[props.page] || 'All',
  );

  const [photoData, setPhotoData] = useState(props.photos);
  const [videoData, setVideoData] = useState(props.videos);
  const [booksData, setbooksData] = useState(props.books);
  const [hideMoreBooks, setHideMoreBooks] = useState(props.books.length < 10);
  const [bio, setBio] = useState(props.bio || []);
  const [filmographyData, setfilmographyData] = useState(props.filmography);
  const [hideMoreFilmography, setHideMoreFilmography] = useState(
    props.filmography.length < 33,
  );
  const [awardsData, setawardsData] = useState(props.awards);
  const [newsSearchData, setNewsSearchData] = useState(
    props.news || newsData.items || [],
  );
  const [isLoadingPhotoData, setIsLoadingPhotoData] = useState(false);
  const [isLoadingVideoData, setIsLoadingVideoData] = useState(false);
  const [isLoadingNewsData, setIsLoadingNewsData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [photoCurPage, setPhotoCurPage] = useState(curpg);
  const [videoCurPage, setVideoCurPage] = useState(curpg);
  const [newsCurPage, setNewsCurPage] = useState(curpg);

  const [booksCurPage, setBooksCurPage] = useState(curpg);
  const [filmographyCurPage, setFilmographyCurPage] = useState(curpg);

  const [hideNewsMoreButton, setHideNewsMoreButton] = useState(false);
  const [hidePhotoMoreButton, setHidePhotoMoreButton] = useState(
    inititalHidePhotoMoreButton,
  );
  const [hideVideoMoreButton, setHideVideoMoreButton] = useState(
    inititalHideVideoMoreButton,
  );
  const [lastSearchKeyword, setLastSearchKeyword] = useState('');
  const [searchResults, setSearchResults] = useState();
  const [searchedValue, setSearchedValue] = useState('');
  const searchInput = useRef(null);
  const [showSocialWidget, setShowSocialWidget] = useState(false);
  const [shareUrl, setShareUrl] = useState('');
  const [photogalleryRendered, setPhotogalleryRendered] = useState(
    photogalleryDataRendered,
  );
  const [photostoryRendered, setPhotostoryRendered] = useState(
    photostoryDataRendered,
  );
  const [photoStoryCurPage, setPhotoStoryCurPage] = useState(0);
  const [photoGalleryCurPage, setPhotoGalleryCurPage] = useState(0);
  const [isSearchedKeyValied, setIsSearchedKeyValied] = useState(
    !!isSearchedKeywordValid(searchKeyword),
  );

  const initCurrentPages = () => {
    setPhotoCurPage(1);
    setVideoCurPage(1);
    setNewsCurPage(1);
    setPhotoStoryCurPage(0);
    setPhotoGalleryCurPage(0);
    setPhotogalleryRendered(0);
    setPhotostoryRendered(0);
  };

  useEffect(
    () => {
      if (photoCurPage === 1) {
        if (photostoryRendered === 0 && photogalleryRendered > 0) {
          setPhotoStoryCurPage(0);
          setPhotoGalleryCurPage(
            Math.ceil(photogalleryRendered / photoLoadMoreDataCount),
          );
        } else if (photostoryRendered > 0 && photogalleryRendered > 0) {
          setPhotoStoryCurPage(
            Math.ceil(photostoryRendered / photoLoadMoreDataCount),
          );
          setPhotoGalleryCurPage(
            Math.ceil(photogalleryRendered / photoLoadMoreDataCount),
          );
        } else if (photostoryRendered > 0 && photogalleryRendered === 0) {
          setPhotoStoryCurPage(
            Math.ceil(photostoryRendered / photoLoadMoreDataCount),
          );
          setPhotoGalleryCurPage(0);
        } else {
          setPhotoStoryCurPage(0);
          setPhotoGalleryCurPage(0);
        }
      }
    },
    [photostoryRendered, photogalleryRendered],
  );

  const setNonInterActionGa = (flag = true) => {
    if (typeof window !== 'undefined') {
      window.isGaNonInteractive = flag;
    }
  };

  const changeUrl = (tab, curpgval = 1) => {
    let newUrl = `${location.origin}/topic/${searchKeyword}`;
    tab = tab.toLowerCase();
    newUrl =
      tab && tab !== 'all'
        ? `${newUrl}/${
            // eslint-disable-next-line no-nested-ternary
            tab === 'articles' ? 'news' : tab === 'filmography' ? 'movies' : tab
          }`
        : newUrl;
    newUrl = curpgval > 1 ? `${newUrl}/${curpgval}` : newUrl;
    history.pushState({}, document.title, newUrl);

    if (typeof window !== 'undefined') {
      setShareUrl(window.location.href);
    }
  };

  const getPhotoData = (
    perpage = 4,
    curpgval = 1,
    append = false,
    fromViewAllTab = false,
  ) => {
    // if (!append) setPhotoData([]);
    const url = `${TOPIC_API_URL}${searchKeyword}/photos&row=${perpage}&curpg=${curpgval}`;
    makeRequest
      .get(url, {})
      .then(photoTopicData => {
        if (
          photoTopicData &&
          photoTopicData.data &&
          photoTopicData.data.contentsData &&
          photoTopicData.data.contentsData.items
        ) {
          if (append && photoData && curpgval > 1) {
            setPhotoData([
              ...photoData,
              ...photoTopicData.data.contentsData.items,
            ]);
            setPhotoCurPage(photoCurPage + 1);
            // updateing the url when user clicks on load more button
            // changeUrl('photos', curpgval);
          } else setPhotoData([...photoTopicData.data.contentsData.items]);
          if (
            Array.isArray(photoTopicData.data.contentsData.items) &&
            (photoTopicData.data.contentsData.items.length === 0 ||
              photoTopicData.data.contentsData.items.length < perpage)
          )
            setHidePhotoMoreButton(true);
          else setHidePhotoMoreButton(false);
          if (append && curpgval >= 20) {
            setHidePhotoMoreButton(true);
          }
          setIsLoading(false);
          if (
            photoTopicData.data.contentsData.items.length === 0 &&
            curpgval === 1 &&
            !fromViewAllTab
          )
            sendGaThroughProps({
              data: {
                gaCategory,
                gaAction: `Search_Result`,
                gaLabel: `No_Result_found-${searchKeyword}`,
              },
            });
        } else {
          setIsLoading(false);
          setIsLoadingPhotoData(false);
        }
      })
      .catch(err => {
        console.log('Error1', err);
        setIsLoading(false);
        setIsLoadingPhotoData(false);
      });
  };

  const getPhotoGalleryData = (
    photogalleryUrl,
    photoStoryResponse,
    append,
    curpgval,
    perpage,
  ) => {
    let responseData = [];
    let photogalleryRenderedNum = 0;
    makeRequest
      .get(photogalleryUrl, {})
      .then(photogalResponse => {
        if (
          photogalResponse &&
          photogalResponse.data &&
          photogalResponse.data.contentsData &&
          photogalResponse.data.contentsData.items
        ) {
          if (photoStoryResponse && photoStoryResponse.length > 0) {
            responseData = [
              ...photoStoryResponse,
              ...photogalResponse.data.contentsData.items,
            ].slice(0, perpage);
          } else {
            responseData = photogalResponse.data.contentsData.items;
          }
          setPhotoGalleryCurPage(photoGalleryCurPage + 1);
          photogalleryRenderedNum =
            responseData.length - photoStoryResponse.length;
          setPhotogalleryRendered(
            append
              ? photogalleryRendered + photogalleryRenderedNum
              : photogalleryRenderedNum,
          );
        }
        if (append && photoData && curpgval > 1) {
          setPhotoData([...photoData, ...responseData]);
          setPhotoCurPage(photoCurPage + 1);
        } else {
          setPhotoData([...responseData]);
        }
        if (
          Array.isArray(responseData) &&
          (responseData.length === 0 || responseData.length < perpage)
        ) {
          setHidePhotoMoreButton(true);
        } else {
          setHidePhotoMoreButton(false);
        }
        setIsLoadingPhotoData(false);
        setIsLoading(false);
      })
      .catch(err => {
        console.log(err);
        setIsLoadingPhotoData(false);
        setIsLoading(false);
      });
  };

  const getCombinedPhotoData = (
    perpage = 4,
    curpgval = 1,
    photostoryCurpg = 1,
    photogalleryCurpg = 1,
    append = false,
  ) => {
    const photostoryUrl = `${TOPIC_API_URL}${searchKeyword}/photos&row=${perpage}&curpg=${photostoryCurpg}&hostid=83`;
    const photogalleryUrl = `${TOPIC_API_URL}${searchKeyword}/photos&row=${perpage}&curpg=${photogalleryCurpg}&hostid=34`;
    if (photogalleryRendered <= 0 || !append) {
      makeRequest
        .get(photostoryUrl, {})
        .then(photostoryResponse => {
          if (
            photostoryResponse &&
            photostoryResponse.data &&
            photostoryResponse.data.contentsData &&
            photostoryResponse.data.contentsData.items
          ) {
            const responseData = photostoryResponse.data.contentsData.items;
            setBio(photostoryResponse.data.contentsData.bio);
            setPhotoStoryCurPage(photoStoryCurPage + 1);
            setPhotostoryRendered(
              append
                ? photostoryRendered + responseData.length
                : responseData.length,
            );

            if (responseData.length < perpage) {
              getPhotoGalleryData(
                photogalleryUrl,
                photostoryResponse.data.contentsData.items,
                append,
                curpgval,
                perpage,
              );
            } else {
              if (append && photoData && curpgval > 1) {
                setPhotoData([...photoData, ...responseData]);
                setPhotoCurPage(photoCurPage + 1);
              } else {
                setPhotoData([...responseData]);
              }

              if (
                Array.isArray(responseData) &&
                (responseData.length === 0 || responseData.length < perpage)
              ) {
                setHidePhotoMoreButton(true);
              } else {
                setHidePhotoMoreButton(false);
              }
            }
            // if (curpgval > 1) {
            // changeUrl('photos', curpgval);
            // }
            setIsLoadingPhotoData(false);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setHidePhotoMoreButton(true);
            setIsLoadingPhotoData(false);
          }
        })
        .catch(err => {
          console.log(err);
          setIsLoading(false);
          setIsLoadingPhotoData(false);
        });
    } else {
      getPhotoGalleryData(photogalleryUrl, [], append, curpgval, perpage);
      // if (curpgval > 1) {
      // changeUrl('photos', curpgval);
      // }
    }
    if (curpgval >= 20) {
      setHidePhotoMoreButton(true);
    }
  };

  const getVideoData = (
    perpage = 4,
    curpgval = 1,
    append = false,
    fromViewAllTab = false,
  ) => {
    // if (!append) setVideoData([]);
    const url = `${TOPIC_API_URL}${searchKeyword}/videos&row=${perpage}&curpg=${curpgval}`;
    makeRequest
      .get(url, {})
      .then(videoTopicData => {
        if (
          videoTopicData &&
          videoTopicData.data &&
          videoTopicData.data.contentsData &&
          videoTopicData.data.contentsData.items
        ) {
          setIsLoadingVideoData(false);
          setBio(videoTopicData.data.contentsData.bio);
          if (append && videoData && curpgval > 1) {
            setVideoData([
              ...videoData,
              ...videoTopicData.data.contentsData.items,
            ]);
            setVideoCurPage(videoCurPage + 1);
            // updateing the url when user clicks on load more button
            // changeUrl('videos', curpgval);
          } else setVideoData([...videoTopicData.data.contentsData.items]);
          if (
            Array.isArray(videoTopicData.data.contentsData.items) &&
            (videoTopicData.data.contentsData.items.length === 0 ||
              videoTopicData.data.contentsData.items.length < perpage)
          )
            setHideVideoMoreButton(true);
          else setHideVideoMoreButton(false);
          if (curpgval >= 20) {
            setHideVideoMoreButton(true);
          }
          setIsLoading(false);
          if (
            videoTopicData.data.contentsData.items.length === 0 &&
            curpgval === 1 &&
            !fromViewAllTab
          )
            sendGaThroughProps({
              data: {
                gaCategory,
                gaAction: `Search_Result`,
                gaLabel: `No_Result_found-${searchKeyword}`,
              },
            });
        } else {
          setIsLoading(false);
          setHideVideoMoreButton(true);
        }
      })
      .catch(err => {
        console.log('Error1', err);
        setIsLoading(false);
      });
  };

  const getNewsdata = (perpage = 4, curpgval = 1, append = false) => {
    // if (!append) setNewsSearchData([]);
    const url = `${TOPIC_API_URL}${searchKeyword}/news&row=${perpage}&curpg=${curpgval}`;
    makeRequest
      .get(url, {})
      .then(newsTopicData => {
        if (
          newsTopicData &&
          newsTopicData.data &&
          newsTopicData.data.contentsData &&
          newsTopicData.data.contentsData.items
        ) {
          setIsLoadingNewsData(false);
          setBio(newsTopicData.data.contentsData.bio);
          if (append && newsSearchData && curpgval > 1) {
            setNewsSearchData([
              ...newsSearchData,
              ...newsTopicData.data.contentsData.items,
            ]);
            setNewsCurPage(newsCurPage + 1);
            // updateing the url when user clicks on load more button
            // changeUrl('news', curpgval);
          } else setNewsSearchData([...newsTopicData.data.contentsData.items]);
          if (
            Array.isArray(newsTopicData.data.contentsData.items) &&
            (newsTopicData.data.contentsData.items.length === 0 ||
              newsTopicData.data.contentsData.items.length < perpage)
          )
            setHideNewsMoreButton(true);
          else setHideNewsMoreButton(false);
          if (curpgval >= 20) {
            setHideNewsMoreButton(true);
          }
          setIsLoading(false);
          if (
            newsTopicData.data.contentsData.items.length === 0 &&
            curpgval === 1
          )
            sendGaThroughProps({
              data: {
                gaCategory,
                gaAction: `Search_Result`,
                gaLabel: `No_Result_found-${searchKeyword}`,
              },
            });
        } else {
          setHideNewsMoreButton(true);
          setIsLoading(false);
        }
      })
      .catch(err => {
        console.log('Error1', err);
        setIsLoading(false);
      });
  };

  const getAllData = (perpage = 4, curpgval = 1, append = false) => {
    // if (!append) setNewsSearchData([]);x
    const url = `${TOPIC_API_URL}${searchKeyword}/news&row=${perpage}&curpg=${curpgval}`;
    makeRequest
      .get(url, {})
      .then(allTopicData => {
        if (
          allTopicData &&
          allTopicData.data &&
          allTopicData.data.contentsData &&
          allTopicData.data.contentsData.items
        ) {
          setIsLoadingNewsData(false);
          if (append && newsSearchData) {
            setNewsSearchData([
              ...newsSearchData,
              ...allTopicData.data.contentsData.items,
            ]);
            setNewsCurPage(newsCurPage + 1);
            const dataItems = _get(
              allTopicData.data.contentsData,
              'items',
              undefined,
            );
            if (
              Array.isArray(dataItems) &&
              newsSearchData &&
              (dataItems.length === 0 ||
                (dataItems.length < perpage &&
                  [...dataItems, ...newsSearchData].length === totalCount))
            )
              setHideNewsMoreButton(true);
            else setHideNewsMoreButton(false);
            // updateing the url when user clicks on load more button
            // changeUrl('all', curpgval);
          } else {
            setNewsSearchData([...allTopicData.data.contentsData.items]);
            if (
              Array.isArray(allTopicData.data.contentsData.items) &&
              newsSearchData &&
              (allTopicData.data.contentsData.items.length === 0 ||
                (allTopicData.data.contentsData.items.length < perpage ||
                  [...allTopicData.data.contentsData.items].length ===
                    totalCount))
            )
              setHideNewsMoreButton(true);
            else setHideNewsMoreButton(false);
          }
          // if (
          //   Array.isArray(allTopicData.data.contentsData.items) &&
          //   (allTopicData.data.contentsData.items.length === 0 ||
          //     allTopicData.data.contentsData.items.length < perpage)
          // )
          //   setHideNewsMoreButton(true);
          // else setHideNewsMoreButton(false);
          if (curpgval >= 20) {
            setHideNewsMoreButton(true);
          }
          setIsLoading(false);
          if (
            allTopicData.data.contentsData.items.length === 0 &&
            curpgval === 1
          )
            sendGaThroughProps({
              data: {
                gaCategory,
                gaAction: `Search_Result`,
                gaLabel: `No_Result_found-${searchKeyword}`,
              },
            });
        } else {
          setIsLoading(false);
          setHideNewsMoreButton(true);
        }
      })
      .catch(err => {
        console.log('Error1', err);
        setIsLoading(false);
      });
  };

  const getEtimesTabData = (info = {}) => {
    const { perpage = 4, curpgval = 1, tabSelected, append = false } = info;
    const tabsUrl = [];
    const msid = topicData?.relatedCmsEntities[0]?.msId;
    if (tabSelected) {
      tabsUrl.push(
        `${TOPIC_API_URL}${
          tabSelected === 'awards' ? msid : searchKeyword
        }/${tabSelected}&row=${perpage}&curpg=${curpgval}`,
      );
    } else {
      for (let i = 0; i < tabsData.length; i += 1) {
        const tabValue = tabsData[i].name.toLowerCase();
        if (
          tabValue !== 'all' &&
          tabValue !== 'videos' &&
          tabValue !== 'photos' &&
          tabValue !== 'articles'
        ) {
          tabsUrl.push(
            `${TOPIC_API_URL}${
              tabValue === 'awards' ? msid : searchKeyword
            }/${tabValue}&row=${perpage}&curpg=${curpgval}`,
          );
        }
      }
    }
    const url = [];
    for (let i = 0; i < tabsUrl.length; i += 1) {
      url.push(makeRequest.get(tabsUrl[i]));
    }
    Promise.all(url)
      .then(data => {
        setIsLoading(false);
        for (let i = 0; i < data.length; i += 1) {
          const tnType = data[i].data.contentsData.tn;
          const tabRelatedData = data[i].data.contentsData.items;
          const bioData = data[i].data.contentsData.bio;
          setBio(bioData);
          if (tnType === 'filmography') {
            if (append && filmographyData && curpgval > 1) {
              setfilmographyData([...filmographyData, ...tabRelatedData]);
              // changeUrl('filmography', curpgval);
              setFilmographyCurPage(filmographyCurPage + 1);
              setHideMoreFilmography(tabRelatedData < 30 || curpgval >= 20);
            } else {
              setfilmographyData(tabRelatedData);
            }
          } else if (tnType === 'awards') {
            setawardsData(tabRelatedData);
          } else if (tnType === 'books') {
            if (append && booksData && curpgval > 1) {
              setbooksData([...booksData, ...tabRelatedData]);
              setHideMoreBooks(tabRelatedData < 10 || curpgval >= 20);
            } else {
              setbooksData(tabRelatedData);
            }
            setBooksCurPage(booksCurPage + 1);
          }
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const viewAll = () => {
    setIsLoading(true);
    getAllData(20);
    getPhotoData(4, 1, true, true);
    getVideoData(4, 1, true, true);
    setSelectedTab('All');
    getEtimesTabData();
    changeUrl('');
  };
  const viewTabContent = tabSelected => {
    setIsLoading(true);
    getEtimesTabData({ perpage: 30, tabSelected });
    setSelectedTab(tabSelected);
    changeUrl(tabSelected);
    if (document.getElementById('All')) {
      const top = document.getElementById('All').offsetTop;
      document.body.scrollTop = top - 50;
      document.documentElement.scrollTop = top - 50;
    }
  };
  const viewNews = () => {
    setIsLoading(true);
    getNewsdata(30);
    setSelectedTab('Articles');
    changeUrl('news');
  };
  const viewPhotos = (fetchMoreFlag = null) => {
    initCurrentPages();
    setIsLoading(true);
    getCombinedPhotoData(33);
    setSelectedTab('Photos');
    changeUrl('photos');
    if (fetchMoreFlag && document.getElementById('All')) {
      const top = document.getElementById('All').offsetTop;
      document.body.scrollTop = top - 50;
      document.documentElement.scrollTop = top - 50;
      sendGaThroughProps({
        data: {
          gaCategory,
          gaAction: `Search_Result-${selectedTab}`,
          gaLabel: `View_More-View_All-photos`,
        },
      });
    }
  };

  const viewVideos = (fetchMoreFlag = null) => {
    setIsLoading(true);
    getVideoData(40);
    setSelectedTab('Videos');
    changeUrl('videos');
    if (fetchMoreFlag && document.getElementById('All')) {
      const top = document.getElementById('All').offsetTop;
      document.body.scrollTop = top - 50;
      document.documentElement.scrollTop = top - 50;
      sendGaThroughProps({
        data: {
          gaCategory,
          gaAction: `Search_Result-${selectedTab}`,
          gaLabel: `View_More-View_All-Videos`,
        },
      });
    }
  };

  const mapTabNameToURL = tabName => {
    const tabValue = tabName.toLowerCase();
    let result;
    switch (tabValue) {
      case 'articles':
        result = '/news';
        break;
      case 'photos':
      case 'videos':
      case 'books':
      case 'filmography':
      case 'awards':
        result = `/${tabValue}`;
        break;
      default:
        result = '';
        break;
    }
    return result;
  };

  const triggerGA = tabName => {
    gaWrapper(
      'send',
      'pageview',
      `https://timesofindia.indiatimes.com/topic/${searchKeyword}${tabName}${
        frmEtimes ? '?et=entertainment' : ''
      }`,
    );
  };
  const loadTabData = event => {
    if (event) event.preventDefault();
    setIsLoading(true);
    initCurrentPages();
    const tab =
      (event && event.target && event.target.id) ||
      pageToTabMapping[props.page];
    const tabValue = tab?.toLowerCase();
    switch (tabValue) {
      case 'all':
        viewAll();
        triggerGA('/');
        if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            event: 'page_view',
            page_url: `https://timesofindia.indiatimes.com/topic/${searchKeyword}${`/`}`,
          });
        }
        break;
      case 'articles':
        viewNews();
        triggerGA('/news');
        if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            event: 'page_view',
            page_url: `https://timesofindia.indiatimes.com/topic/${searchKeyword}${`/news`}`,
          });
        }
        break;
      case 'photos':
        viewPhotos();
        triggerGA('/photos');
        if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            event: 'page_view',
            page_url: `https://timesofindia.indiatimes.com/topic/${searchKeyword}${`/photos`}`,
          });
        }
        break;
      case 'videos':
        viewVideos();
        triggerGA('/videos');
        if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            event: 'page_view',
            page_url: `https://timesofindia.indiatimes.com/topic/${searchKeyword}${`/videos`}`,
          });
        }
        break;
      default:
        viewTabContent(tabValue);
        triggerGA(`/${tabValue}`);
        break;
    }
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: `Search_Result-${selectedTab}`,
        gaLabel: `Tab-Switch_Tab-${tab}`,
      },
    });
  };

  const loadMoreTabData = (tabclicked, baseCount) => {
    if (tabclicked === 'books') {
      getEtimesTabData({
        perpage: baseCount || 20,
        tabSelected: tabclicked,
        curpgval: booksCurPage + 1,
        append: true,
      });
    } else if (tabclicked === 'filmography') {
      getEtimesTabData({
        perpage: baseCount || 20,
        tabSelected: tabclicked,
        curpgval: filmographyCurPage + 1,
        append: true,
      });
    }
  };
  const loadMoreNews = baseCount => {
    setIsLoadingNewsData(true);
    if (newsCurPage && newsCurPage > 0) {
      getNewsdata(baseCount || 20, newsCurPage + 1, true);
      sendGaThroughProps({
        data: {
          gaCategory,
          gaAction: `Search_Result-${selectedTab}`,
          gaLabel: `View_More-Load_More-News`,
        },
      });
    }
  };

  const loadMoreAllData = baseCount => {
    setIsLoadingNewsData(true);
    if (newsCurPage && newsCurPage > 0) {
      getAllData(baseCount || 15, newsCurPage + 1, true);
      sendGaThroughProps({
        data: {
          gaCategory,
          gaAction: `Search_Result-${selectedTab}`,
          gaLabel: `View_More-Load_More-All`,
        },
      });
    }
  };

  const loadMoreVideos = baseCount => {
    setIsLoadingVideoData(true);
    if (videoCurPage && videoCurPage > 0) {
      getVideoData(baseCount || 20, videoCurPage + 1, true);
      sendGaThroughProps({
        data: {
          gaCategory,
          gaAction: `Search_Result-${selectedTab}`,
          gaLabel: `View_More-Load_More-Videos`,
        },
      });
    }
  };

  const loadMorePhotos = baseCount => {
    setIsLoadingPhotoData(true);
    if (photoCurPage && photoCurPage > 0) {
      // getPhotoData(baseCount || 20, photoCurPage + 1, true);
      getCombinedPhotoData(
        baseCount || 20,
        photoCurPage + 1,
        photoStoryCurPage + 1,
        photoGalleryCurPage + 1,
        true,
      );
      sendGaThroughProps({
        data: {
          gaCategory,
          gaAction: `Search_Result-${selectedTab}`,
          gaLabel: `View_More-Load_More-Photos`,
        },
      });
    }
  };

  const fetchSearchResults = event => {
    const apiDetails = getSearchApi();
    let search = event.target.value || '';
    setSearchedValue(search);
    search = search.trim();
    let url = `${apiDetails.endpoint}?q=${search}`;
    apiDetails.params.forEach(item => {
      url += `&${item.key}=${item.value}`;
    });
    if (!search || !isSearchedKeywordValid(search)) {
      setSearchResults([]);
    }
    setLastSearchKeyword(search);
    if (!isSearchedKeywordValid(search)) {
      setIsSearchedKeyValied(false);
    }
    if (
      !search ||
      search === lastSearchKeyword ||
      !isSearchedKeywordValid(search)
    ) {
      return;
    }
    setIsSearchedKeyValied(true);
    jsonp(url, null, (err, data) => {
      if (
        data &&
        data instanceof Array &&
        data.length &&
        data[1] &&
        data[1] instanceof Array
      )
        setSearchResults(data[1]);
    });
  };

  const markSelectedItem = () => {
    const results = Object.assign([], this.state.searchResults);
    const selected = results.filter(item => item.isSelected);
    let indexToHighlight;
    if (!selected.length) {
      indexToHighlight = 0;
    } else {
      const currentHighlightedIndex = results.indexOf(selected[0]);
      if (currentHighlightedIndex === results.length - 1) {
        indexToHighlight = 0;
      } else {
        results[currentHighlightedIndex + 1].isSelected = true;
      }

      results[indexToHighlight].isSelected = true;
      results[currentHighlightedIndex].isSelected = false;
    }
    setSearchResults(results);
  };
  const onKeyDown = event => {
    const keyCode = event.keyCode || event.which;
    if (keyCode === 40 || keyCode === 38) {
      markSelectedItem(keyCode);
    }
  };
  const onFormSubmit = event => {
    event.preventDefault();
    // const resultLink = Search.getItemLink(searchResults[0]);
    // if (resultLink) {
    //   window.location.href = resultLink;
    // }
    if (!isSearchedKeywordValid(searchedValue)) return false;
    if (searchedValue) {
      sendGaThroughProps({
        data: {
          gaAction: `Search_Result-${selectedTab}`,
          gaLabel: `Search_Bar-Search_Initiate_Manually_Entered-${searchedValue}`,
        },
      });
      window.location.href = `/topic/${searchedValue}`;
    }
    return false;
  };

  const sendGaOnSuggestionCLick = keyword => {
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: `Search_Result-${selectedTab}`,
        gaLabel: `Search_Bar-Search_Initiate_Auto_Suggestion-${keyword}`,
      },
    });
  };

  const sendGaOnSearchCLick = () => {
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: `Search_Result-${selectedTab}`,
        gaLabel: `Search_Bar-Search_Click`,
      },
    });
  };

  const renderResultItem = resultItem => (
    <div className={s.autosuggest}>
      <ul>
        {resultItem.map(data => (
          <li>
            {data &&
            Array.isArray(data) &&
            data.length &&
            data[0] &&
            isSearchedKeywordValid(data[0]) ? (
              <Link
                to={Search.getItemLink(data)}
                onClick={() =>
                  sendGaOnSuggestionCLick(
                    data && Array.isArray(data) && data[0],
                  )
                }
              >
                {data[0]}
              </Link>
            ) : (
              data[0]
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  const handleFocus = () => {
    searchInput.current.focus();
  };

  const clearSearch = () => {
    setSearchResults();
    setSearchedValue('');
    handleFocus();
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: `Search_Result-${selectedTab}`,
        gaLabel: `Search_Bar-Search_Clear`,
      },
    });
  };

  const formatCards = data =>
    data.map(el => ({
      hl: el.hl,
      wu: el.wu || el.overridelink,
    }));

  const changeSearchTextToDefault = event => {
    if (event.target.value === '' && searchKeyword) {
      setSearchedValue(searchKeyword.split('-').join(' '));
      setSearchResults();
    }
  };

  const getLeaderboardAds = (pos, pageType) => {
    const leaderboardAd = _get(props, 'revenueAds.dfp.leaderboards');
    return leaderboardAd
      ? {
          ...leaderboardAd,
          divId: `${leaderboardAd?.divId}-${pos}-${pageType || ''}`,
        }
      : undefined;
  };

  useEffect(
    () => {
      if (
        selectedTab === 'All' &&
        newsSearchData &&
        Array.isArray(newsSearchData) &&
        newsSearchData.length === totalCount
      )
        setHideNewsMoreButton(true);
    },
    [totalCount],
  );
  useEffect(() => {
    getExperimentRefresh(props.refreshTime);
  }, []);

  useEffect(() => {
    setSearchedValue(searchKeyword && searchKeyword.split('-').join(' '));
    // if (!props.page && queryParam !== '') {
    //   if (!props.page && queryParam !== '') {
    //   getPhotoData(4, 1, false, true);
    //   getVideoData(4, 1, false, true);
    // }
    // checkAndApplyFilter();
    if (typeof window !== 'undefined') {
      setShareUrl(window.location.href);
    }
    if (selectedTab === 'All' && totalCount < 1)
      sendGaThroughProps({
        data: {
          gaCategory,
          gaAction: `Search_Result`,
          gaLabel: `No_Result_found-${searchKeyword}`,
        },
      });
  }, []);
  const showSocialShareWidget = () => {
    setShowSocialWidget(true);
  };

  const hideSocialShareWidget = () => {
    setShowSocialWidget(false);
  };

  const socialWidgetToggle = () => {
    setShowSocialWidget(!showSocialWidget);
  };

  const returnZeroTabData = () => {
    if (selectedTab === 'Articles' && newsSearchData?.length === 0) return true;
    else if (selectedTab === 'Photos' && photoData?.length === 0) return true;
    else if (selectedTab === 'Videos' && videoData?.length === 0) return true;
    else if (selectedTab === 'All' && totalCount === 0) return true;
    return false;
  };
  return (
    <UseIntersectionObeserver.Provider value>
      <div className={s.search_topic_wrapper}>
        <div className="breadcrumb">
          <BreadCrumb
            data={frmEtimes ? etBreadcrumbs : breadcrumbs}
            wrapperClass="breadcrumb"
          />
        </div>
        {topicData &&
          topicData.uid && (
            <div
              className={`${s.search_box} ${
                searchResults ? s.autosuggest_pop : ``
              }`}
            >
              <form
                onSubmit={event => {
                  onFormSubmit(event);
                }}
              >
                <div className={s.input_wrap}>
                  <input
                    value={searchedValue}
                    onKeyDown={event => onKeyDown(event)}
                    onChange={event => fetchSearchResults(event)}
                    ref={searchInput}
                    tabIndex="1"
                    id="searchField"
                    autoComplete="off"
                    name="query"
                    className="textbox"
                    type="text"
                    onClick={() => {
                      sendGaOnSearchCLick();
                    }}
                    onBlur={event => changeSearchTextToDefault(event)}
                    // onFocus={onFocusSearch}
                  />
                  <div className={s.search_close}>
                    {searchedValue && (
                      <i className={s.close_icon} onClick={clearSearch} />
                    )}
                    <i
                      className={`${s.search_icon} ${
                        !isSearchedKeyValied ? s.disable : ''
                      }`}
                      onClick={
                        searchKeyword !== searchedValue ? onFormSubmit : ''
                      }
                    />
                  </div>
                </div>
                {/* <Search
            theme="snowwhite"
            isWapView={false}
            sticky={false}
            highlightSearchedWordInResult={true}
          /> */}

                <div className={s.search_number}>
                  Showing <span>{totalCount}</span> results
                </div>
                {searchResults && renderResultItem(searchResults)}
              </form>
            </div>
          )}
        {topicData &&
          topicData.uid && (
            <AboutTopic
              ads={rhsAd}
              isPrime={isPrime}
              gaCategory={gaCategory}
              selectedTab={selectedTab}
              page={page}
              loadAllAds={loadAllAds}
              bio={bio}
              tabSelected={selectedTab}
            />
          )}
        <div className={s.filterStoryWrapper}>
          <div>
            <div id="storyBody">
              <div className={s.filter_tabs}>
                <div className={s.tabs_block}>
                  {(!topicData || (topicData && !topicData.uid)) && (
                    <div
                      className={`${s.search_box} ${
                        searchResults ? s.autosuggest_pop : ``
                      }`}
                    >
                      <form
                        onSubmit={event => {
                          onFormSubmit(event);
                        }}
                      >
                        <div className={s.input_wrap}>
                          <input
                            value={searchedValue}
                            onKeyDown={event => onKeyDown(event)}
                            onChange={event => fetchSearchResults(event)}
                            ref={searchInput}
                            tabIndex="1"
                            id="searchField"
                            autoComplete="off"
                            name="query"
                            className="textbox"
                            type="text"
                            onClick={() => {
                              sendGaOnSearchCLick();
                            }}
                            // onFocus={onFocusSearch}
                            onBlur={event => changeSearchTextToDefault(event)}
                          />
                          <div className={s.search_close}>
                            {searchedValue && (
                              <i
                                className={s.close_icon}
                                onClick={clearSearch}
                              />
                            )}
                            <i
                              className={`${s.search_icon} ${
                                !isSearchedKeyValied ? s.disable : ''
                              }`}
                              onClick={
                                searchKeyword !== searchedValue
                                  ? onFormSubmit
                                  : ''
                              }
                            />
                          </div>
                        </div>
                        {/* <Search
            theme="snowwhite"
            isWapView={false}
            sticky={false}
            highlightSearchedWordInResult={true}
          /> */}
                        {(!topicData || (topicData && !topicData.uid)) &&
                          totalCount !== 0 &&
                          !returnZeroTabData() && (
                            <div className={s.searchfor}>
                              <div>
                                <span>You have searched for</span>
                                <h1>{searchKeyword.split('-').join(' ')}</h1>
                              </div>
                              <div className={s.search_number}>
                                , Showing <span>{totalCount}</span> results
                              </div>
                            </div>
                          )}
                        {searchResults && renderResultItem(searchResults)}
                      </form>
                    </div>
                  )}
                  {/* Commented as specified by the product to remove TOI+ stories and MREC on Search Page */}
                  {/* {!topicData && <ToiPlusWidgets isPrime={isPrime} ads={rhsAd} />} */}

                  {tabsData &&
                  Array.isArray(tabsData) &&
                  tabsData.length &&
                  tabsData[0].count &&
                  tabsData[0].count !== 0 ? (
                    <div className={`${s.tabs_btns_block} ${s.all_tabs}`}>
                      <div className={s.tabs_btns}>
                        {tabsData.map(tabData => (
                          <>
                            {(tabData.name.toLowerCase() ===
                              selectedTab.toLowerCase() ||
                              (tabData && tabData.count !== 0)) && (
                              <a
                                className={`${
                                  pageToTabMapping[selectedTab] ===
                                    tabData.name ||
                                  tabData.name.toLowerCase() ===
                                    selectedTab.toLowerCase()
                                    ? s.selected
                                    : ''
                                }`}
                                onClick={loadTabData}
                                id={tabData.name}
                                href={`https://timesofindia.indiatimes.com/topic/${searchKeyword}${mapTabNameToURL(
                                  tabData.name,
                                )}`}
                              >
                                {tabData.name}
                                {tabData.name?.toLowerCase() !== 'books' && (
                                  <span id={tabData.name}>
                                    ({tabData.count})
                                  </span>
                                )}
                              </a>
                            )}
                          </>
                        ))}
                      </div>
                      <div
                        className={`${s.timelineshare}`}
                        // onClick={isWapView && socialWidgetToggle}
                        onMouseEnter={showSocialShareWidget}
                        onMouseLeave={hideSocialShareWidget}
                      >
                        <i
                          className={`${s.shareicon} ${
                            showSocialWidget ? s.active : ''
                          }`}
                        />
                        {showSocialWidget && (
                          <SocialSharing
                            styles={s}
                            url={shareUrl}
                            wu={shareUrl}
                            via="@timesofindia"
                            linkeDin
                            isTablet
                            wrapperClass=""
                            gaCategory="gaCategory"
                            gaLabel="topic_share"
                            socialWidgetToggle={socialWidgetToggle}
                            liveblogMailHeading="Mail this story"
                            defaultEmailView
                            disableShortUrl
                          />
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
                {totalCount !== 0 ? (
                  <div className={s.tabs_content}>
                    {selectedTab === 'All' && (
                      <div>
                        {setNonInterActionGa(false)}
                        {newsSearchData &&
                          Array.isArray(newsSearchData) &&
                          newsSearchData.length > 0 && (
                            <TileWidget
                              allepisodes={newsSearchData}
                              headingName={
                                searchKeyword &&
                                typeof searchKeyword === 'string'
                                  ? `${searchKeyword.split('-').join(' ')} News`
                                  : 'News'
                              }
                              getLeaderboardAds={getLeaderboardAds}
                              isPrime={isPrime}
                              loadMoreNews={() => loadMoreAllData(20)}
                              hideNewsMoreButton={hideNewsMoreButton}
                              isLoadingNewsData={isLoadingNewsData}
                              sendGaThroughProps={sendGaThroughProps}
                              selectedTab={selectedTab}
                            />
                          )}
                        {/* {!isPrime &&
                        midad && (
                          <div className={s.ad_wrap}>
                            <AdCaller data={midad} />
                          </div>
                        )} */}
                        {booksData &&
                          Array.isArray(booksData) &&
                          booksData.length > 0 && (
                            <div className="videoWrapper">
                              {((photoData &&
                                Array.isArray(videoData) &&
                                videoData.length > 0) ||
                                (newsSearchData &&
                                  Array.isArray(newsSearchData) &&
                                  newsSearchData.length > 0)) && (
                                <span className={s.doubleboder_top} />
                              )}
                              <TopicCard
                                cards={booksData}
                                headline={
                                  searchKeyword &&
                                  typeof searchKeyword === 'string'
                                    ? `${searchKeyword
                                        .split('-')
                                        .join(' ')} Books`
                                    : 'Books'
                                }
                                cardType={TOPIC_CARD_TYPE.BOOKS}
                                loadMoreTabData={viewTabContent}
                                classname="card_20"
                              />
                            </div>
                          )}
                        {photoData &&
                          Array.isArray(photoData) &&
                          photoData.length > 0 && (
                            <div className="photoWrapper">
                              {newsSearchData &&
                                Array.isArray(newsSearchData) &&
                                newsSearchData.length > 0 && (
                                  <span className={s.doubleboder_top} />
                                )}
                              <PhotoVideoTile
                                topicData={photoData}
                                headingName={
                                  searchKeyword &&
                                  typeof searchKeyword === 'string'
                                    ? `${searchKeyword
                                        .split('-')
                                        .join(' ')} Photos`
                                    : 'Photos'
                                }
                                getLeaderboardAds={getLeaderboardAds}
                                isPrime={isPrime}
                                isPhotosTile
                                viewPhotos={viewPhotos}
                                sendGaThroughProps={sendGaThroughProps}
                                selectedTab={selectedTab}
                                isNoLink
                                noLinkClass="nolink"
                              />
                            </div>
                          )}
                        {videoData &&
                          Array.isArray(videoData) &&
                          videoData.length > 0 && (
                            <div className="videoWrapper">
                              {((photoData &&
                                Array.isArray(photoData) &&
                                photoData.length > 0) ||
                                (newsSearchData &&
                                  Array.isArray(newsSearchData) &&
                                  newsSearchData.length > 0)) && (
                                <span className={s.doubleboder_top} />
                              )}
                              <PhotoVideoTile
                                topicData={videoData}
                                headingName={
                                  searchKeyword &&
                                  typeof searchKeyword === 'string'
                                    ? `${searchKeyword
                                        .split('-')
                                        .join(' ')} Videos`
                                    : 'Videos'
                                }
                                viewVideos={viewVideos}
                                sendGaThroughProps={sendGaThroughProps}
                                selectedTab={selectedTab}
                                getLeaderboardAds={getLeaderboardAds}
                                isPrime={isPrime}
                              />
                              {frmEtimes ? (
                                <span className={s.doubleboder_top} />
                              ) : null}
                            </div>
                          )}
                        {Array.isArray(filmographyData) &&
                        filmographyData.length > 0 ? (
                          <>
                            <TopicCard
                              cards={filmographyData}
                              headline={
                                searchKeyword &&
                                typeof searchKeyword === 'string'
                                  ? `${searchKeyword
                                      .split('-')
                                      .join(' ')} Filmography`
                                  : 'Filmography'
                              }
                              cardType={TOPIC_CARD_TYPE.FILMOGRAPHY}
                              classname="card_20 all_filmo"
                              loadMoreTabData={viewTabContent}
                            />
                            <span className={s.doubleboder_top} />
                          </>
                        ) : null}
                        {Array.isArray(awardsData) && awardsData.length > 0 ? (
                          <AwardsSection
                            headline={
                              searchKeyword && typeof searchKeyword === 'string'
                                ? `${searchKeyword.split('-').join(' ')} Awards`
                                : 'Awards'
                            }
                            cards={awardsData}
                          />
                        ) : null}
                      </div>
                    )}
                    {isLoading && <LoaderSpinner />}
                    {selectedTab === 'Articles' &&
                      Array.isArray(newsSearchData) &&
                      (newsSearchData.length > 0 ? (
                        <div>
                          {setNonInterActionGa(false)}
                          <TileWidget
                            headingName={
                              searchKeyword && typeof searchKeyword === 'string'
                                ? `${searchKeyword.split('-').join(' ')} News`
                                : 'News'
                            }
                            getLeaderboardAds={getLeaderboardAds}
                            isPrime={isPrime}
                            allepisodes={newsSearchData}
                            loadMoreNews={() => loadMoreNews(30)}
                            hideNewsMoreButton={hideNewsMoreButton}
                            isLoadingNewsData={isLoadingNewsData}
                            sendGaThroughProps={sendGaThroughProps}
                            selectedTab={selectedTab}
                          />
                        </div>
                      ) : (
                        <div>
                          {setNonInterActionGa()}
                          <NoResultTopStories
                            noResultTextToDisplay="Sorry, We couldn’t find any results."
                            topStories={
                              props.topStories && props.topStories.items
                            }
                            selectedTab={selectedTab}
                          />
                        </div>
                      ))}
                    {selectedTab === 'Photos' &&
                      Array.isArray(photoData) &&
                      (photoData.length > 0 ? (
                        <div>
                          {setNonInterActionGa(false)}
                          {photoData[0]?.tn === 'photoGallery' ? (
                            <PhotosSection
                              cards={photoData}
                              title={topicData?.title}
                              loadMorePhotos={loadMorePhotos}
                              hidePhotoMoreButton={hidePhotoMoreButton}
                              headingName={
                                searchKeyword &&
                                typeof searchKeyword === 'string'
                                  ? `${searchKeyword
                                      .split('-')
                                      .join(' ')} Photos`
                                  : 'Photos'
                              }
                            />
                          ) : (
                            <PhotoVideoTile
                              topicData={photoData}
                              headingName={
                                searchKeyword &&
                                typeof searchKeyword === 'string'
                                  ? `${searchKeyword
                                      .split('-')
                                      .join(' ')} Photos`
                                  : 'Photos'
                              }
                              isPhotosTile
                              loadMorePhotos={() => loadMorePhotos(33)}
                              hidePhotoMoreButton={hidePhotoMoreButton}
                              isLoadingPhotoData={isLoadingPhotoData}
                              sendGaThroughProps={sendGaThroughProps}
                              selectedTab={selectedTab}
                              getLeaderboardAds={getLeaderboardAds}
                              isPrime={isPrime}
                            />
                          )}
                        </div>
                      ) : (
                        <div>
                          {setNonInterActionGa()}
                          <NoResultTopStories
                            noResultTextToDisplay="Sorry, We couldn’t find any results."
                            topStories={
                              props.topStories && props.topStories.items
                            }
                            selectedTab={selectedTab}
                          />
                        </div>
                      ))}

                    {selectedTab === 'Videos' &&
                      Array.isArray(videoData) &&
                      (videoData.length > 0 ? (
                        <div>
                          {setNonInterActionGa(false)}
                          <PhotoVideoTile
                            topicData={videoData}
                            headingName={
                              searchKeyword && typeof searchKeyword === 'string'
                                ? `${searchKeyword.split('-').join(' ')} Videos`
                                : 'Videos'
                            }
                            loadMoreVideos={() => loadMoreVideos(40)}
                            hideVideoMoreButton={hideVideoMoreButton}
                            isLoadingVideoData={isLoadingVideoData}
                            sendGaThroughProps={sendGaThroughProps}
                            selectedTab={selectedTab}
                            getLeaderboardAds={getLeaderboardAds}
                            isPrime={isPrime}
                          />
                        </div>
                      ) : (
                        <div>
                          {setNonInterActionGa()}
                          <NoResultTopStories
                            noResultTextToDisplay="Sorry, We couldn’t find any results."
                            topStories={
                              props.topStories && props.topStories.items
                            }
                            selectedTab={selectedTab}
                          />
                        </div>
                      ))}

                    {selectedTab?.toLowerCase() === 'filmography' &&
                      Array.isArray(filmographyData) &&
                      (filmographyData.length > 0 ? (
                        <>
                          {setNonInterActionGa(false)}
                          <Filmography
                            data={filmographyData}
                            classname="topicfilmography"
                            loadMoreTabData={loadMoreTabData}
                            hideMoreFilmography={hideMoreFilmography}
                            headline={
                              searchKeyword && typeof searchKeyword === 'string'
                                ? `${searchKeyword
                                    .split('-')
                                    .join(' ')} Filmography`
                                : 'Filmography'
                            }
                          />
                        </>
                      ) : null)}
                    {selectedTab?.toLowerCase() === 'books' &&
                      Array.isArray(booksData) &&
                      (booksData.length > 0 ? (
                        <>
                          {setNonInterActionGa(false)}
                          <TopicCard
                            cards={booksData}
                            cardType={TOPIC_CARD_TYPE.BOOKS}
                            loadMoreTabData={loadMoreTabData}
                            classname="card_20 bookstabselected"
                            hideMoreBooks={hideMoreBooks}
                            headline={
                              searchKeyword && typeof searchKeyword === 'string'
                                ? `${searchKeyword.split('-').join(' ')} Books`
                                : 'Books'
                            }
                          />
                        </>
                      ) : null)}

                    {selectedTab?.toLowerCase() === 'awards' &&
                      Array.isArray(awardsData) &&
                      (awardsData.length > 0 ? (
                        <>
                          {setNonInterActionGa(false)}
                          <AwardsSection
                            headline={
                              searchKeyword && typeof searchKeyword === 'string'
                                ? `${searchKeyword.split('-').join(' ')} Awards`
                                : 'Awards'
                            }
                            cards={awardsData}
                          />
                        </>
                      ) : null)}
                  </div>
                ) : (
                  <div className={s.tabs_content}>
                    {setNonInterActionGa()}
                    <NoResultTopStories
                      noResultTextToDisplay={`${`Sorry, We couldn’t find any results`}`}
                      topStories={props.topStories && props.topStories.items}
                      noTabRender
                    />
                  </div>
                )}
              </div>
            </div>
            <div>
              {frmEtimes ? (
                <>
                  {Array.isArray(trendingCelebs) &&
                  trendingCelebs.length > 0 ? (
                    <>
                      <span className={s.doubleboder_top} />
                      <TopicCard
                        cards={trendingCelebs?.slice(0, 6)}
                        headline="Trending Celebs"
                        cardType={TOPIC_CARD_TYPE.CELEBSCARDS}
                        classname="card_20 trending_celeb"
                      />
                    </>
                  ) : null}
                  {Array.isArray(relatedCelebs) && relatedCelebs.length > 0 ? (
                    <>
                      <span className={s.doubleboder_top} />
                      <RelatedCelebs
                        cards={relatedCelebs?.slice(0, 15)}
                        page={props.page}
                      />
                    </>
                  ) : null}
                  {moreFromEtimesData && (
                    <>
                      <span className={s.doubleboder_top} />
                      <div className={s.secWrap}>
                        <div className={s.secWrapWs}>
                          <div className={s.ftLogoWrap} />
                          <LinksList
                            sectionData={{
                              data: formatCards(moreFromEtimesData?.items),
                            }}
                            hideSliderName
                          />
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </UseIntersectionObeserver.Provider>
  );
}
const mapStateToProps = state => ({
  tabsData: _get(state, 'topic.tabsData', {}),
  totalCount: _get(state, 'topic.totalCount', 0),
  adData: _get(state, `topic.contentsData.ads`, []),
  pubOrderList: _get(state, `topic.pubOrderList.items`, []),
  showPrimeFilter: _get(state, `topic.showPrimeFilter`, false),
  breadcrumbs: _get(state, `header.data.navigation.breadcrumbs`, []),
  etBreadcrumbs: _get(state, `topic.topic.breadcrumbs`, []),
  seo: _get(state, 'topic.seo', {}),
  photogalleryDataRendered: _get(state, `topic.photogalleryDataRendered`, 0),
  photostoryDataRendered: _get(state, `topic.photostoryDataRendered`, 0),
  topStories: _get(state, `topic.topStories`, {}),
  keywordsFacet: _get(state, 'topic.keywordsFacet', {}),
  revenueAds: _get(state, 'revenue.data.ads.content'),
  books: _get(state, `topic.books`, []),
  filmography: _get(state, `topic.filmography`, []),
  awards: _get(state, `topic.awards`, []),
  frmEtimes: _get(state, `topic.fromEtimes`, false),
  trendingCelebs: _get(state, 'topic.trendingCelebs', []),
  relatedCelebs: _get(state, 'topic.relatedCelebs', []),
  moreFromEtimes: _get(state, 'homepage_etimes.data.sections', []),
  bio: _get(state, 'topic.bio', []),
});
const mapDispatchToProps = dispatch => ({
  // setLatestTabData: (params, queryParam, isFilterApply) => {
  //   dispatch(loadTopicTabData(params, queryParam, isFilterApply));
  // },
  loadKeywordsFacet: (params, callback) => {
    dispatch(loadKeywordsFacetData(params, callback));
  },
  loadAllAds: (params, path) => {
    dispatch(loadAllAdsFromQueue(params, path));
  },
});

Topic.propTypes = {
  refreshTime: PropTypes.number,
};
Topic.defaultProps = {
  refreshTime: 0,
};

export default connect(mapStateToProps, mapDispatchToProps)(Topic);
